import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { closeDialog } from "store/actions/utilActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { CreateCustomerDialogContentProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import CreateCustomer from "./createCustomer";
//#endregion

const CreateCustomerDialogContent: React.FC<CreateCustomerDialogContentProps> = (props) => {
  const { customerName, onFormSubmitSuccess } = props;

  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onSubmitSuccess = (customerId?: number, customerName?: string) => {
    onFormSubmitSuccess && onFormSubmitSuccess(customerId, customerName);
    dispatch(closeDialog());
  };

  return <CreateCustomer onFormSubmitSuccess={onSubmitSuccess} customerName={customerName}></CreateCustomer>;
};

export default CreateCustomerDialogContent;
